import { fetchCurrentUser } from '../../ducks/user.duck';
import { getShopifyFeeReportApi } from '../../util/api';

const ns = 'app/AdminPanelShopifyFeeReportPage';

export const FETCH_FEE_EVENTS_REQUEST = `${ns}/FETCH_FEE_EVENTS_REQUEST`;
export const FETCH_FEE_EVENTS_SUCCESS = `${ns}/FETCH_FEE_EVENTS_SUCCESS`;
export const FETCH_FEE_EVENTS_ERROR = `${ns}/FETCH_FEE_EVENTS_ERROR`;

const initialState = {
  feeEvents: [],
  feeEventsPagination: null,
  feeEventsInProgress: false,
  feeEventsError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_FEE_EVENTS_REQUEST:
      return { ...state, feeEventsInProgress: true, feeEventsError: null };
    case FETCH_FEE_EVENTS_SUCCESS:
      return {
        ...state,
        feeEventsInProgress: false,
        feeEvents: payload.events,
        feeEventsPagination: payload.pagination,
      };
    case FETCH_FEE_EVENTS_ERROR:
      return { ...state, feeEventsInProgress: false, feeEventsError: payload };
    default:
      return state;
  }
}

const fetchFeeEventsRequest = () => ({ type: FETCH_FEE_EVENTS_REQUEST });
const fetchFeeEventsSuccess = data => ({ type: FETCH_FEE_EVENTS_SUCCESS, payload: data });
const fetchFeeEventsError = err => ({ type: FETCH_FEE_EVENTS_ERROR, payload: err });

export const fetchAdminShopifyFeeEvents = ({
  userId,
  page = 1,
  perPage = 10,
  month,
  year,
  monthYears,
  checkoutStatus,
  searchKeyword,
} = {}) => dispatch => {
  dispatch(fetchFeeEventsRequest());
  return getShopifyFeeReportApi({
    adminReport: true,
    userId,
    page,
    perPage,
    month,
    year,
    monthYears,
    checkoutStatus,
    searchKeyword,
  })
    .then(res =>
      dispatch(
        fetchFeeEventsSuccess({ events: res.events || [], pagination: res.pagination || null })
      )
    )
    .catch(e => dispatch(fetchFeeEventsError(e?.message || 'Failed to load Shopify fees')));
};

export const loadData = () => (dispatch, getState) => {
  return dispatch(fetchCurrentUser()).then(() => {
    const currentUser = getState().user.currentUser;
    const { isShopifyAdmin } = currentUser?.attributes?.profile?.privateData || {};
    if (isShopifyAdmin) {
      return dispatch(fetchAdminShopifyFeeEvents({  checkoutStatus: 'COMPLETED' }));
    }
    return null;
  });
};
